import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpenBankingClientInfo } from '@compiere-ws/models/openbanking/open-banking-client-info';
import { AppConfig } from '@iupics-config/app.config.service';
import { IupicsCookieService } from '@iupics-manager/managers/security-manager/cookies/iupics-cookie.service';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OpenBankingService {
  private readonly openBankingURL: string;

  constructor(
    private http: HttpClient,
    private config: AppConfig,
    private cookieService: IupicsCookieService
  ) {
    this.openBankingURL = this.config.getBackendResource('openBanking') || 'openBanking';
  }

  public syncTransactions(bankAccountApiConnectionId: number, bankAccountId: number): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.openBankingURL}/syncTransactions/${bankAccountApiConnectionId}/${bankAccountId}`
    );
  }
  public testConnection(bankAccountApiConnectionId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.openBankingURL}/testConnection/${bankAccountApiConnectionId}`);
  }

  public openBankingLinkUrl(bankAccountApiConnectionId: number): Observable<string> {
    return this.http.get<OpenBankingClientInfo>(`${this.openBankingURL}/clientInfo/${bankAccountApiConnectionId}`).pipe(
      switchMap((clientInfo) => {
        const baseUrl = clientInfo.base_uri;
        const params = new URLSearchParams();
        params.set('client_id', clientInfo.client_id);
        params.set('redirect_uri', clientInfo.redirect_uri);
        params.set('response_type', 'code');
        params.set('scope', clientInfo.scope);
        const url = new URL(window.location.href);
        const afterOrigin = url.pathname + url.search + url.hash;
        this.cookieService.setAndEncryptLocalStorage('openbanking_connection_id', bankAccountApiConnectionId + '');
        params.set('state', afterOrigin);
        params.set('code_challenge', clientInfo.code_challenge);
        params.set('code_challenge_method', clientInfo.challenge_method);
        if (clientInfo.onboarding_details_id) params.set('onboarding_details_id', clientInfo.onboarding_details_id);
        params.set('language', clientInfo.language);
        const finalUrl = `${baseUrl}?${params.toString()}`;
        return of(finalUrl);
      })
    );
  }

  public openBankingConfirmCode(code: string, bankAccountApiConnectionId: number): Observable<boolean> {
    return this.http.post<any>(`${this.openBankingURL}/code/${bankAccountApiConnectionId}`, code).pipe(
      switchMap((token) => {
        console.log(token);
        return of(token != null);
      })
    );
  }
}
